import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@material-ui/core";
import {
  CLICKED_CLOSE_TRIPS_REPLATFORM_NOTICE,
  CLICKED_NAVIGATE_TO_PORTAL_TRIPS_REPLATFORM_NOTICE,
  VIEWED_TRIPS_REPLATFORM_NOTICE,
} from "redmond";
import { useInView } from "react-intersection-observer";
import {
  BannerSeverity,
  Icon,
  IconName,
  NotificationBanner,
  SanitizedHtml, useDeviceTypes,
} from "halifax";
import { useTripsReplatformNoticeBanner } from "./useTripsReplatformNoticeBanner";
import {
  CORPORATE_PORTAL_TRIPS_URL,
  getTripsReplatformNoticeDescription,
  TRIPS_REPLATFORM_NOTICE_LINK_CLASS,
  TRIPS_REPLATFORM_NOTICE_TITLE,
} from "./textConstants";
import { trackEvent } from "../../../../api/v1/analytics/trackEvent";
import "./styles.scss";
import clsx from "clsx";
import {getConfigTenant, isVesperTenant} from "@capone/common";

export interface TripsReplatformNoticeBannerProps {
  isConsumerMultiPortal: boolean;
}

export const TripsReplatformNoticeBanner = ({
  isConsumerMultiPortal,
}: TripsReplatformNoticeBannerProps) => {
  const { isOpen, onDismiss } = useTripsReplatformNoticeBanner({
    isConsumerMultiPortal,
  });
  const hasTrackedView = useRef(false);
  const { matchesMobile } = useDeviceTypes();
  const [bannerRef, inView] = useInView({
    threshold: 0.5,
    triggerOnce: true,
    initialInView: false,
  });

  useEffect(() => {
    if (isOpen && inView && !hasTrackedView.current) {
      hasTrackedView.current = true;
      trackEvent({
        eventName: VIEWED_TRIPS_REPLATFORM_NOTICE,
        properties: {},
      });
    }
  }, [isOpen, inView]);

  if (!isOpen) {
    return null;
  }

  const handleDismiss = () => {
    trackEvent({
      eventName: CLICKED_CLOSE_TRIPS_REPLATFORM_NOTICE,
      properties: {},
    });
    onDismiss();
  };

  const handleDescriptionClick = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    if (target.classList.contains(TRIPS_REPLATFORM_NOTICE_LINK_CLASS)) {
      trackEvent({
        eventName: CLICKED_NAVIGATE_TO_PORTAL_TRIPS_REPLATFORM_NOTICE,
        properties: {},
      });
    }
  };

  return (
    <div ref={bannerRef} className={clsx("trips-replatform-notice-banner-container", { mobile: matchesMobile })}>
      <NotificationBanner
        className="trips-replatform-notice-banner"
        severity={BannerSeverity.NOTICE}
        icon={<Icon name={IconName.InfoCircleFill} />}
        onDismiss={handleDismiss}
        content={
          <Box className="trips-replatform-notice-banner-content">
            <Typography
              variant="body2"
              className="trips-replatform-notice-banner-title"
            >
              {TRIPS_REPLATFORM_NOTICE_TITLE}
            </Typography>
            <SanitizedHtml
              as={Typography}
              variant="body2"
              className="trips-replatform-notice-banner-description"
              onClick={handleDescriptionClick}
              html={getTripsReplatformNoticeDescription(
                CORPORATE_PORTAL_TRIPS_URL
              )}
            />
          </Box>
        }
      />
    </div>
  );
};
